import { render, staticRenderFns } from "./getImgUrl.vue?vue&type=template&id=ccfcda72&"
import script from "./getImgUrl.vue?vue&type=script&lang=js&"
export * from "./getImgUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "getImgUrl.vue"
export default component.exports